angular.module( 'acme.view.application.pos.create.pages.forms.donations', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.pos.create.pages.forms.donations.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var posCreatePagesFormsDonations = {
        name: 'application.pos.create.pages.forms.donations',
        url: '/donations',
        views: {
          "subview-main": {
            controller: 'PosCreatePagesFormsDonationsController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/pos/create/pages/forms/donations/donations.tpl.html'
          }
        },
        data: {
          pageTitle: '     '
        }
      };

    $stateProvider
      .state(posCreatePagesFormsDonations);
});
